export default {
  path: 'clubs',
  component: () => import(/* webpackChunkName: "event" */ './wrapper.vue'),
  children: [{
    path: '/',
    name: 'event.clubs',
    component: () => import(/* webpackChunkName: "event" */ './clubList.vue'),
  }, {
    path: 'add',
    name: 'event.clubs.add',
    component: () => import(/* webpackChunkName: "event" */ './clubAdd.vue'),
  }, {
    path: ':clubId',
    component: () => import(/* webpackChunkName: "event" */ './clubWrapper.vue'),
    children: [{
      path: '/',
      name: 'event.clubs.view',
      component: () => import(/* webpackChunkName: "event" */ './clubView.vue'),
    },{
      path: 'members',
      component: () => import(/* webpackChunkName: "event" */ './memberWrapper.vue'),
      children: [{
        path: '/',
        name: 'event.clubs.members',
        component: () => import(/* webpackChunkName: "event" */ './memberList.vue'),
      },{
        path: ':memberId',
        name: 'event.clubs.members.view',
        component: () => import(/* webpackChunkName: "event" */ './memberView.vue'),
      },{
        path: 'add',
        name: 'event.clubs.members.add',
        component: () => import(/* webpackChunkName: "event" */ './memberAdd.vue'),
      }],
    }, {
      path: 'groups',
      component: () => import(/* webpackChunkName: "event" */ './groupWrapper.vue'),
      children: [{
        path: '/',
        name: 'event.clubs.groups',
        component: () => import(/* webpackChunkName: "event" */ './groupList.vue'),
      }, {
        path: ':groupId',
        name: 'event.clubs.groups.view',
        component: () => import(/* webpackChunkName: "event" */ './groupView.vue'),
      }, {
        path: 'add',
        name: 'event.clubs.groups.add',
        component: () => import(/* webpackChunkName: "event" */ './groupAdd.vue'),
      }],
    },{
      path: 'teams',
      component: () => import(/* webpackChunkName: "event" */ './teamWrapper.vue'),
      children: [{
        path: '/',
        name: 'event.clubs.teams',
        component: () => import(/* webpackChunkName: "event" */ './teamList.vue'),
      },{
        path: ':teamId',
        name: 'event.clubs.teams.view',
        component: () => import(/* webpackChunkName: "event" */ './teamView.vue'),
      },{
        path: 'add',
        name: 'event.clubs.teams.add',
        component: () => import(/* webpackChunkName: "event" */ './teamAdd.vue'),
      }],
    }],
  }],
};
